import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/gifts-hub")({
  component: lazyRouteComponent(() => import("./-pages/admin.gifts-hub")),
  head: () => ({ meta: [{ title: "مركز الهدايا · Lecmo Admin" }] }),
});
